/**
 * E-poçt təsdiqi xəbərdarlığı.
 *
 * NİYƏ AYRICA KOMPONENT
 * İki ekranda lazımdır və ikisi də vacibdir:
 *   • Onboarding — qeydiyyatdan DƏRHAL sonra, məktub hələ gözlənilirkən
 *   • Poçt ekranı — istifadəçi təsdiqləməyi unudubsa
 * Əvvəl yalnız poçt ekranında idi, yəni yeni istifadəçi onu heç görmürdü.
 *
 * ⚠️ ZOLAQ YOLU KƏSMİR. Təsdiqlənməmiş hesab hazırda tam işləyir — bu,
 * şüurlu seçimdir: yeni müştərini ilk dəqiqədə divara çırpmaq onu itirmək
 * deməkdir. Zolaq xatırladır, mane olmur.
 */

import { useState } from 'react';
import { api, ApiError } from '../api';

interface Props {
  /** Qutu ilə girənlərdə təsdiq axını yoxdur — token `users` cədvəlindədir. */
  kind: 'user' | 'mailbox';
  emailVerified: boolean;
}

export function VerifyBanner({ kind, emailVerified }: Props): React.ReactElement | null {
  const [sentTo, setSentTo] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (emailVerified || kind !== 'user') return null;

  if (sentTo) {
    return (
      <div className="banner is-ok" role="status">
        <span>
          Təsdiq məktubu <strong>{sentTo}</strong> ünvanına göndərildi. Gəlmirsə
          spam qovluğuna baxın — bəzən oraya düşür.
        </span>
      </div>
    );
  }

  return (
    <div className="banner is-warn" role="status">
      <span>
        <strong>E-poçt ünvanınız hələ təsdiqlənməyib.</strong>{' '}
        {error ?? 'Qeydiyyatda göndərdiyimiz məktubdakı keçidi açın.'}
      </span>
      <button
        className="btn-text"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          setError(null);
          void api
            .resendVerification()
            .then((r) => setSentTo(r.sentTo))
            .catch((e: unknown) => {
              // ⚠️ Sürət limiti AYRICA izah olunur. «Alınmadı» desək,
              // istifadəçi təkrar-təkrar basar və blok müddəti uzanar.
              setError(
                e instanceof ApiError && e.code === 'too_many_attempts'
                  ? 'Çox cəhd edildi — bir saatdan sonra yenidən yoxlayın.'
                  : 'Məktub göndərilmədi. Bir azdan yenidən yoxlayın.',
              );
            })
            .finally(() => setBusy(false));
        }}
      >
        {busy ? 'Göndərilir…' : 'Yenidən göndər'}
      </button>
    </div>
  );
}
